import { ConfirmProps } from 'components/shared/dialogs/Confirm/Confirm.types';
import { useTranslator } from 'components/shared/hooks/useTranslator/useTranslator';
import React, { FC } from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { useModalClosedContext } from 'context/ModalClosedContext';

export const Confirm: FC<ConfirmProps> = (props) => {
  const trans = useTranslator();
  const { notifyModalClosed } = useModalClosedContext();

  const handleCancel = () => {
    props.cancel?.();
    notifyModalClosed();
  };

  const handleConfirm = () => {
    props.confirm();
    notifyModalClosed();
  };

  return (
    <Dialog disableEscapeKeyDown aria-labelledby="confirm-title" open={props.open}>
      {props.title && <DialogTitle id="confirm-title">{trans(props.title)}</DialogTitle>}
      <DialogContent>
        <DialogContentText>
          {props.children ? props.children : trans(props.message, props.messageValues)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {props.cancel ? (
          <Button onClick={handleCancel} color="secondary" variant="outlined" data-testid="confirm-no">
            {trans('COMMON.NO')}
          </Button>
        ) : null}
        <Button onClick={handleConfirm} color="secondary" variant="contained" data-testid="confirm-yes">
          {props.confirmLabel ? props.confirmLabel : trans('COMMON.YES')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
